import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Navigation from './components/Navigation';
import SideNavigation from './components/SideNavigation';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Calendar from './pages/Calendar';
import EventDetail from './pages/EventDetail';
import HomePage from './pages/HomePage';
import Friends from './pages/Friends';
import AddFriend from './pages/AddFriend';
import InvitePage from './pages/InvitePage';
import PublicProfile from './pages/PublicProfile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import PrivateRoute from './components/PrivateRoute';
import Language from './pages/Language';
import About from './pages/About';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <div className="side-area side-area-left">
          </div>
          
          <div className="floating-layout">
            <Navigation />
            <div className="floating-row">
              <div className="floating-box">
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
                  <Route path="/" element={<PrivateRoute><HomePage /></PrivateRoute>} />
                  <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                  <Route path="/calendar" element={<PrivateRoute><Calendar /></PrivateRoute>} />
                  <Route path="/event/:id" element={<PrivateRoute><EventDetail /></PrivateRoute>} />
                  <Route path="/friends" element={<PrivateRoute><Friends /></PrivateRoute>} />
                  <Route path="/add-friend" element={<PrivateRoute><AddFriend /></PrivateRoute>} />
                  <Route path="/users/:username" element={<PublicProfile />} />
                  <Route path="/verify-email/:uid/:token" element={<VerifyEmail />} />
                  <Route path="/invite/:username" element={<InvitePage />} />
                  <Route path="/language" element={<Language />} />
                  <Route path="/about" element={<About />} />
                </Routes>
              </div>
            </div>
          </div>
          
          <div className="side-area side-area-right">
            <SideNavigation />
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
